import { inWindowsOS } from './inWindowsOS';

import { FILE_TYPES } from './constants';

/**
 * Returns true if a File matches one of a list of accepted types, based on matching logic that
 * utilizes both the MIME type and extension as appropriate.
 */
export const hasAcceptedFileType = (
    file: File,
    acceptedFileTypeKeys: FileTypeKey[],
): boolean => {
    if (acceptedFileTypeKeys.length === 0) {
        return true;
    }

    const { name, type } = file;

    let foundMatch = false;

    for (const acceptedFileTypeKey of acceptedFileTypeKeys) {
        const { mimeTypes, extensions } = FILE_TYPES[acceptedFileTypeKey];

        // In all these cases, we can't trust the MIME type on file.type.
        if (inWindowsOS || type === '' || type === undefined) {
            // MIME types are generated differently in Windows vs. Linux. For example,
            // 'application/vnd.ms-excel' is sometimes associated with .csv files by Windows,
            // but that is the same MIME type used by .xls files, which are a vector for scripting
            // attacks.
            const extensionMatch = name.match(/.(\w+)$/);

            if (extensionMatch !== null) {
                const extension = extensionMatch[1];

                if (extensions.includes(extension)) {
                    foundMatch = true;
                    break;
                }
            }
        } else if (mimeTypes.includes(type)) {
            // If we have a trustable MIME type to check against, use that.
            foundMatch = true;
            break;
        }
    }

    return foundMatch;
};
